import { defineComponent as _defineComponent } from 'vue'
import { AlertBlock, IconBase } from '@shared/ui';
    import { asyncSvgLoader } from '@shared/lib';
    import confirm from './images/confirm.svg';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TourAttentionAlert',
  setup(__props) {

    const confirmIcon = asyncSvgLoader(confirm);


return { __sfc: true,confirmIcon, AlertBlock, IconBase }
}

})